import getCountryCodeByLocale from "./getCountryCodeByLocale";

const getIsDeliveryFromOriginCountry = (defaultLocale: string, countryFrom: string): boolean => {
  const originCountryCode = getCountryCodeByLocale(defaultLocale);

  return countryFrom === originCountryCode;
};
export default getIsDeliveryFromOriginCountry;
